// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("@rescript/react/src/React.bs.js");

let make = React.lazy_(() => import("./PropertiesPageRelayMap.bs.js").then(m => m.make));

exports.make = make;
/* make Not a pure module */
